import { apiEndpoints } from "../../utils/constants/apiEndpoints";
import moment from "moment";
import axiosRequest from "../../utils/helpers/axiosRequest";

const baseURL = process.env.REACT_APP_API_URL;
// const baseURL = "https://ca99cd95.ngrok.io/";

export const userService = {
  login,
  forgetPassword,
  reset_password,
  logout,
  // refreshToken,
  setLocalStorage,
  clearLocalStorage,
  updateProfile,
  getCountries,
  changePassword,
  getTickerNews,
  loadMapData,
  loadMapTodaysData,
  getMapFilterResults,
  getMapFilterResultsNextPage,
  getMapFilterMetaResults,
  savePolygon,
  editPolygon,
  deletePolygon,
  recieve_polygon,
  getAreas,
};

function setLocalStorage(response) {
  localStorage.setItem("token", response.access);
  localStorage.setItem("connection_time", moment().format("hh:mm A"));
  // localStorage.setItem('disconnection_time', moment().add(12, 'minutes').format('hh:mm A'));
}

function clearLocalStorage() {
  var key;
  const keysToRemove = [
    "subscription_details",
    "localTourGuide",
    "token_type",
    "tickerLoading",
    "token",
    "connection_time",
    "disconnection_time",
    "refresh_token",
    "user",
    "user_type",
  ];
  for (key of keysToRemove) {
    localStorage.removeItem(key);
  }
}

async function login(requestData) {
  let response = await axiosRequest(
    "post",
    `${baseURL}` + apiEndpoints.LOGIN,
    false
  )(requestData);
  return response;
}

async function forgetPassword(requestData) {
  let response = await axiosRequest(
    "post",
    `${baseURL}` + apiEndpoints.FORGET_PASSWORD,
    false
  )(requestData);
  return response;
}

async function reset_password(requestData) {
  let response = await axiosRequest(
    "post",
    `${baseURL}` + apiEndpoints.RESET_PASSWORD,
    false
  )(requestData);
  return response;
}

async function logout(requestData) {
  let response = await axiosRequest(
    "post",
    `${baseURL}` + apiEndpoints.LOGOUT,
    true
  )(requestData);
  return response;
}

async function updateProfile(requestData) {
  let response = await axiosRequest(
    "put",
    `${baseURL}` + apiEndpoints.UPDATE_PROFILE,
    true
  )(requestData);
  return response;
}

async function getCountries() {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.CHANGE_COUNTRY,
    true
  )();
  return response;
}

async function changePassword(requestData) {
  let response = await axiosRequest(
    "post",
    `${baseURL}` + apiEndpoints.CHANGE_PASSWORD,
    true
  )(requestData);
  return response;
}

// async function refreshToken(requestData) {
//     let response = await axiosRequest('post', `${baseURL}` + apiEndpoints.JWT_REFRESH, true)(requestData);
//     return response;
// }

async function getTickerNews() {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.GET_TICKER_NEWS,
    true
  )();
  return response;
}

async function loadMapData(param) {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.LOAD_MAP,
    true
  )(param);
  return response;
}

async function loadMapTodaysData(requestData) {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.MAP_FILTER_RESULT + "?" + requestData,
    true
  )();
  return response;
}

async function getMapFilterResults(requestData) {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.MAP_FILTER_RESULT + "?" + requestData,
    true
  )();
  return response;
}
async function getMapFilterResultsNextPage(url) {
  let response = await axiosRequest("get", url, true)();
  return response;
}

async function getMapFilterMetaResults() {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.MAP_FILTER_META_RESULT,
    true
  )();
  return response;
}

async function savePolygon(requestData) {
  let response = await axiosRequest(
    "post",
    `${baseURL}` + apiEndpoints.POLYGON,
    true
  )(requestData);
  return response;
}

async function editPolygon(requestData) {
  let response = await axiosRequest(
    "patch",
    `${baseURL}` + apiEndpoints.POLYGON + requestData.id + "/",
    true
  )(requestData);
  return response;
}

async function deletePolygon(id) {
  let response = await axiosRequest(
    "delete",
    `${baseURL}` + apiEndpoints.POLYGON + id + "/",
    true
  )();
  return response;
}

async function recieve_polygon() {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.POLYGON,
    true
  )();
  return response;
}

async function getAreas(requestData) {
  let response = await axiosRequest(
    "get",
    `${baseURL}` + apiEndpoints.MAP_FILTER_META_RESULT + "?" + requestData,
    true
  )();
  return response;
}
